<template>
  <div class="table_actions">
    <call-tooltip
      placement="top"
      content="Edit">
      <call-button
        outlet
        type="success"
        round
        not-border
        :icon="dataReadingIcon"
        @click="clickAction('update')" />
    </call-tooltip>
    <call-tooltip
      placement="top"
      :content="!blocked ? 'Active' : 'Deactivated'">
      <call-button
        outlet
        :type="blocked ? 'danger' : 'success'"
        round
        not-border
        :icon="blocked ? dataBanIcon : dataCheckIcon"
        @click="clickAction('blocked')" />
    </call-tooltip>
  </div>
</template>

<script>
import CallButton from '../common/CallButton';
import { faBan, faCheck, faPen } from '@fortawesome/pro-regular-svg-icons';

export default {
  name: 'CallTableSmsTemplateActions',
  components: { CallButton },
  props: {
    blocked: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dataBanIcon: faBan,
      dataCheckIcon: faCheck,
      dataReadingIcon: faPen
    };
  },
  methods: {
    clickAction (action) {
      this.$emit('on-action', action);
    }
  }
};
</script>
